import axios from 'axios';
import {errorInterceptor, requestInterceptor, responseInterceptor} from "./common_functions";
const meetingBaseUrl = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL
});
meetingBaseUrl.interceptors.request.use(requestInterceptor);
meetingBaseUrl.interceptors.response.use(responseInterceptor, errorInterceptor);
export { meetingBaseUrl};
